import moment from 'moment';

export const date = (date: string, format = 'MMM DD, YYYY'): string => {
  return date ? moment(date).format(format) : '-';
};
